module.exports = {
  fetch: `query getAnswers {
    answers {
      id
      caption {
        en
        es
      }
    }
  }`,
};
